import { useEffect, useState } from "react";

import { useUserContext } from "../context/UserContext";
import OpportunityJourneyContainerWrapper from "../components/opportunity-referral-pipeline/OpportunityJourneyContainerWrapper.jsx";

import { useOpportunityJourney } from "../api/opportunities/useOpportunityJourney.js";

export default function OpportunityJourney() {
  const { setLeadId } = useUserContext();
  const { setUserId } = useUserContext();
  const { leadId } = useUserContext();
  const [oppId, setOppId] = useState();
  const [oppType, setOppType] = useState(null);

  useEffect(() => {
    const queryString = window.location.search;
    const queryParams = new URLSearchParams(queryString);
    setOppId(queryParams.get("opp_id") || "No lead ID found");
    setOppType(queryParams.get("opp_type") || "No oppType found");
  }, []);

  const { opportunityData } = useOpportunityJourney(oppId, oppType);

  return (
    <>
      <OpportunityJourneyContainerWrapper oppData={opportunityData} />
    </>
  );
}
